/** Извлекает читаемое сообщение об ошибке из ошибки RTK Query. */
export const getApiErrorMessage = (error: unknown): string => {
  if (!error) return "Неизвестная ошибка"

  const err = error as {
    data?: { message?: string | string[]; error?: string }
    error?: string
    message?: string
    status?: number | string
  }

  const data = err.data
  if (data?.message) {
    return Array.isArray(data.message) ? data.message.join("\n") : data.message
  }
  if (typeof err.error === "string") return err.error
  if (typeof err.message === "string") return err.message
  if (data?.error) return data.error
  return "Произошла ошибка"
}
